import React from 'react';
import block from 'bem-cn-lite';
import TextArea from './TextArea/';
import { Comments, Avatars } from '../Components/Comments';
import Repeater from '../Components/Repeater';
import TrialTooltip from '../Components/TrialTooltip';
import ProofingPanel from '../Components/ProofingPanel';
import { TransitionGroup } from 'react-transition-group';
import { FadeTransition, SlideUpTransition } from '../Components/Transitions';
import createEvent from '../createCustomEvent';
import i18n from '../i18n';

block.setup({
    mod: '--'
});

const text = i18n.t('documentProofing:text');

const initialState = {
    isCommenting: false,
    isDisabled: false,
    isVisibleRepeater: false,
    isVisibleCursorTooltip: true,
    isVisibleTrialTooltip: false,
    isSelectedOnce: false,
    text: text,
    comments: [
        {
            text: i18n.t('documentProofing:firstComment'),
            author: i18n.t('global:projectManager'),
            avatar: Avatars.pm,
            markerColor: '#4488ff',
            time: i18n.t('global:1hour')
        }
    ]
};

class DocumentProofing extends React.Component {
    state = { ...initialState };

    addComment = commentText => {
        const comment = {
            text: commentText,
            time: i18n.t('global:rightNow'),
            avatar: Avatars.cm,
            markerColor: '#f8008c',
            author: i18n.t('global:contentManager')
        };

        const finalComment = {
            text: i18n.t('documentProofing:finalComment'),
            time: i18n.t('global:rightNow'),
            avatar: Avatars.pm,
            markerColor: '#4488ff',
            author: i18n.t('global:projectManager')
        };

        const { comments, isDisabled } = this.state;

        if (isDisabled) {
            return false;
        }

        this.setState({
            comments: [...comments, comment, finalComment],
            isCommenting: false,
            isDisabled: true
        });

        window.dispatchEvent(
            createEvent('DOCUMENT_PROOFING_ACTION', {
                detail: 'Added Comment: ' + commentText
            })
        );

        setTimeout(this.showRepeater, 5000);
    };

    showRepeater = () => {
        this.setState({
            isVisibleRepeater: true
        });
    };

    setInitialState = () => {
        this.setState({ ...initialState, text: this.state.text + ' ' });

        window.dispatchEvent(
            createEvent('DOCUMENT_PROOFING_ACTION', {
                detail: 'Reloaded Screenshoot'
            })
        );
    };

    startCommenting = () => {
        this.setState({
            isCommenting: true,
            isVisibleCursorTooltip: false,
            isSelectedOnce: true
        });

        window.dispatchEvent(
            createEvent('DOCUMENT_PROOFING_ACTION', { detail: 'Selected Text' })
        );

        if (this.textArea) {
            this.textArea.focus();
        }
    };

    showTrialTooltip = () => {
        this.setState({
            isVisibleTrialTooltip: true
        });

        window.dispatchEvent(
            createEvent('DOCUMENT_PROOFING_ACTION', {
                detail: 'Clicked on Panel'
            })
        );

        clearTimeout(this.timerid);

        this.timerid = setTimeout(() => {
            this.hideTrialTooltip();
        }, 2000);
    };

    hideTrialTooltip = () => {
        this.setState({
            isVisibleTrialTooltip: false
        });
    };

    render() {
        const b = block('DocumentProofing');

        const {
            comments,
            isCommenting,
            isVisibleRepeater,
            isDisabled,
            isVisibleTrialTooltip,
            isSelectedOnce,
            text
        } = this.state;

        return (
            <div className={b()}>
                <TransitionGroup>
                    {isVisibleRepeater &&
                        <FadeTransition>
                            <Repeater onClick={this.setInitialState} />
                        </FadeTransition>
                    }
                </TransitionGroup>

                <TransitionGroup>
                    {isVisibleTrialTooltip && 
                        <SlideUpTransition>
                            <TrialTooltip width={'465px'} />
                        </SlideUpTransition>
                    }
                </TransitionGroup>

                <TextArea
                    onSelect={this.startCommenting}
                    isCommenting={isCommenting}
                    isSelectedOnce={isSelectedOnce}
                    isDisabled={isDisabled}
                    text={text}
                />

                <Comments
                    comments={comments}
                    textAreaRef={ref => (this.textArea = ref)}
                    onSubmitCommentInput={this.addComment}
                    userAvatar={Avatars.cm}
                    isVisibleCommentInput={isCommenting}
                />

                <div onClick={this.showTrialTooltip} className={b('panel')}>
                    <ProofingPanel commentsIsActive={true}>
                        <img src="https://cdn.wrike.com/image/__cdnu/illustration_abstract_text-proofing-panel.svg" alt="" />
                    </ProofingPanel>
                </div>
            </div>
        );
    }
}

export default DocumentProofing;
